import { useQuery } from '@tanstack/react-query';
import { dashboardApi, dashboardQueryKeys, type StatisticPeriod } from '../api/dashboard.api';

export function useMDRevenueGraph(period: StatisticPeriod) {
  return useQuery({
    queryKey: dashboardQueryKeys.mdRevenueGraph(period),
    queryFn: () => dashboardApi.getMDRevenueGraph(period),
  });
}
